
const menuItems = state => {
        if(!state.auth.isAuth) {
            return state.authMenuItems
        }
        return state.menuItems                                            
}


export default {
  
  menuItems,
  

};